export default "__VITE_PUBLIC_ASSET__628676a9__"